/** Control loader by key request, to keep loader into end statuses. */
export default {
  change: function (state, params) {
    if (state.requester !== undefined) {
      if (params.mode) {
        state.on = params.mode
        state.requester[params.requester] = params.mode
      } else {
        if (state.requester.hasOwnProperty(params.requester)) {
          delete state.requester[params.requester]
        }
      }
    }

    if (Object.keys(state.requester).length === 0) {
      state.on = false
    }
  }
}
